import uniq from 'lodash/uniq';
import { MakeOptional, PublicSellerGroup } from '../../generated/graphql';

const { REACT_APP_ROOT_URL } = process.env;

type PartialPublicSellerGroup = MakeOptional<
PublicSellerGroup, 'link' | 'names' | 'offset' | 'orders' | 'points' | 'position' | 'tags'
>;

interface ISellerGroupClass extends PartialPublicSellerGroup {
  reversedNames: () => string
  firstNames: () => string
  lastNames: () => string
  orderLink: (slug: string) => string
}

class SellerGroup implements ISellerGroupClass {
  _id: PublicSellerGroup['_id'];
  sellers: PublicSellerGroup['sellers'];
  code: PublicSellerGroup['code'];
  __typename?: PublicSellerGroup['__typename'];
  link?: PublicSellerGroup['link'];
  names?: PublicSellerGroup['names'];
  offset?: PublicSellerGroup['offset'];
  orders?: PublicSellerGroup['orders'];
  points?: PublicSellerGroup['points'];
  position?: PublicSellerGroup['position'];
  tags?: PublicSellerGroup['tags'];

  constructor({
    _id, sellers, code, __typename, link, names, offset, orders, points, position, tags,
  }: PartialPublicSellerGroup) {
    this._id = _id;
    this.sellers = sellers;
    this.code = code;
    this.__typename = __typename;
    this.link = link || undefined;
    this.names = names || undefined;
    this.offset = offset || undefined;
    this.orders = orders || undefined;
    this.points = points || undefined;
    this.position = position || undefined;
    this.tags = tags || undefined;
  }

  reversedNames(): string {
    if (!this.sellers?.length) return '';

    return `${this.lastNames() ? ` ${this.lastNames()}` : ''} ${this.firstNames()}`;
  }

  firstNames(): string {
    if (!this.sellers?.length) return '';
    const filteredSellers = this.sellers?.filter((s) => s.firstName.trim());

    return filteredSellers.map((seller, index) => {
      if (index === filteredSellers.length - 1) return seller.firstName.trim();
      if (index === filteredSellers.length - 2) return `${seller.firstName.trim()} &`;
      return `${seller.firstName.trim()},`;
    }).join(' ');
  }

  lastNames(): string {
    if (!this.sellers?.length) return '';

    return uniq(this.sellers?.map((seller) => seller.lastName).filter(Boolean)).join('-');
  }

  orderLink(slug: string): string {
    return `${REACT_APP_ROOT_URL}/${slug}/${this.code}`;
  }
}

export default SellerGroup;
